import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
const comparisons = [{
  situation: 'Olvida lo aprendido entre clases',
  without: 'Nada para repasar',
  withEco: 'Cuaderno del Milonguero'
}, {
  situation: 'No recuerda las figuras',
  without: 'Depende de su memoria',
  withEco: 'Diccionario Visual de 20 Figuras'
}, {
  situation: 'Miedo a la primera milonga',
  without: 'Sin preparación',
  withEco: 'Guía con códigos y checklist'
}, {
  situation: 'Sin contenido para WhatsApp',
  without: 'Mensajes improvisados',
  withEco: '50 infografías para 12 meses'
}];
const modules = [{
  icon: '📓',
  title: 'Cuaderno del Milonguero',
  desc: 'Notas de clase · Vocabulario · Diario de milongas · Metas semanales'
}, {
  icon: '📖',
  title: 'Diccionario Visual de Figuras',
  desc: '20 figuras con definición, origen, clave y checklist de progreso'
}, {
  icon: '🌙',
  title: 'Guía de Primera Milonga',
  desc: 'Cabeceo · Códigos · Vestimenta · Checklist · 10 preguntas frecuentes'
}, {
  icon: '📊',
  title: 'Bitácora de Progreso',
  desc: '12 semanas de registro · Termómetro de nivel · Hitos personales'
}, {
  icon: '📱',
  title: '50 Infografías para WhatsApp',
  desc: 'Motivación · Técnica · Musicalidad · Comunidad · 12 meses de contenido'
}, {
  icon: '📜',
  title: 'Certificados ProfePack',
  desc: 'Certificado con tu nombre · Guía de 3 estrategias para aprovechar el kit'
}];
export function EliteSection() {
  return <section className="w-full bg-[#0a0a0a] py-14 sm:py-24 px-4 overflow-hidden" data-id="element-36">
      <div className="max-w-2xl mx-auto" data-id="element-37">
        <motion.div className="text-center mb-8 sm:mb-10" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-38">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-white mb-3 leading-tight" data-id="element-39">
            💃 ¿Qué agrega el{' '}
            <span className="text-[#C8962E]" data-id="element-40">Ecosistema del Alumno Pro™</span>?
          </h2>
          <p className="text-gray-400 text-sm sm:text-lg max-w-xl mx-auto leading-relaxed" data-id="element-41">
            Material profesional para tus alumnos. El aprendizaje continúa fuera
            del salón.
          </p>
        </motion.div>

        {/* Comparison Table */}
        <motion.div className="bg-white/[0.02] border border-[#C8962E]/20 rounded-2xl overflow-hidden mb-8 sm:mb-12 shadow-2xl" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-42">
          <div className="grid grid-cols-3 bg-black/60 border-b border-[#C8962E]/30" data-id="element-43">
            <div className="p-2.5 sm:p-4 font-bold text-white text-[11px] sm:text-sm" data-id="element-44">
              Situación
            </div>
            <div className="p-2.5 sm:p-4 font-bold text-gray-500 text-[11px] sm:text-sm text-center border-l border-white/5" data-id="element-45">
              Sin Ecosistema
            </div>
            <div className="p-2.5 sm:p-4 font-bold text-[#C8962E] text-[11px] sm:text-sm text-center border-l border-[#C8962E]/20 bg-[#C8962E]/[0.03]" data-id="element-46">
              Con Ecosistema
            </div>
          </div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.05
            }
          }
        }} data-id="element-47">
            {comparisons.map((row, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              x: -10
            },
            visible: {
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.3
              }
            }
          }} className="grid grid-cols-3 border-b border-white/5 last:border-b-0 hover:bg-white/[0.02] transition-colors" data-id="element-48">
                <div className="p-2.5 sm:p-4 text-gray-300 text-[11px] sm:text-sm flex items-center" data-id="element-49">
                  {row.situation}
                </div>
                <div className="p-2.5 sm:p-4 text-gray-500 text-[11px] sm:text-sm border-l border-white/5 flex items-center justify-center text-center" data-id="element-50">
                  {row.without}
                </div>
                <div className="p-2.5 sm:p-4 text-[#C8962E]/90 font-medium text-[11px] sm:text-sm border-l border-[#C8962E]/10 bg-[#C8962E]/[0.02] flex items-center justify-center text-center" data-id="element-51">
                  {row.withEco}
                </div>
              </motion.div>)}
          </motion.div>
        </motion.div>

        {/* Modules List */}
        <motion.div className="relative bg-[#C8962E]/[0.03] border border-[#C8962E]/15 rounded-2xl p-4 sm:p-6 overflow-hidden" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-52">
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#C8962E]/40 to-transparent" data-id="element-53" />

          <div className="flex items-center justify-center gap-3 mb-4 sm:mb-6" data-id="element-54">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-[#C8962E]/20" data-id="element-55" />
            <h3 className="text-[#C8962E] text-sm sm:text-lg font-black tracking-wide whitespace-nowrap" data-id="element-56">
              ✅ ECOSISTEMA INCLUYE
            </h3>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-[#C8962E]/20" data-id="element-57" />
          </div>

          <motion.div className="space-y-1.5 sm:space-y-2.5" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.06
            }
          }
        }} data-id="element-58">
            {modules.map((mod, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              x: -14
            },
            visible: {
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.35,
                ease: 'easeOut'
              }
            }
          }} className="group flex items-center gap-2.5 sm:gap-3.5 rounded-xl px-3 sm:px-4 py-2 sm:py-3 bg-white/[0.015] hover:bg-white/[0.04] border border-transparent hover:border-[#C8962E]/20 transition-all duration-300" style={{
            borderLeftWidth: 3,
            borderLeftColor: 'transparent'
          }} onMouseEnter={e => {
            e.currentTarget.style.borderLeftColor = 'rgba(200,150,46,0.5)';
          }} onMouseLeave={e => {
            e.currentTarget.style.borderLeftColor = 'transparent';
          }} data-id="element-59">
                <span className="flex-shrink-0 w-7 h-7 sm:w-9 sm:h-9 rounded-lg bg-[#C8962E]/[0.08] flex items-center justify-center text-sm sm:text-lg group-hover:bg-[#C8962E]/[0.15] transition-colors duration-300" data-id="element-60">
                  {mod.icon}
                </span>
                <div className="min-w-0 flex-1" data-id="element-61">
                  <p className="text-white text-xs sm:text-[15px] font-bold leading-snug" data-id="element-62">
                    {mod.title}
                    <span className="text-gray-500 font-normal text-[10px] sm:text-xs ml-1.5 hidden sm:inline" data-id="element-63">
                      — {mod.desc}
                    </span>
                  </p>
                  <p className="text-gray-500 text-[10px] leading-snug mt-0.5 sm:hidden" data-id="element-64">
                    {mod.desc}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}